var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":'/goal/'+_vm.goalId}},[_vm._v("← Go back to goal details")]),(_vm.isReady)?[_c('Kanban',{key:_vm.goalId,attrs:{"goal-id":_vm.goalId}})]:[_vm._v("\n    Loading...\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }